import { render, staticRenderFns } from "./CredenciamentoVisualizacaoDadosEdital.vue?vue&type=template&id=519f1f1e&"
import script from "./CredenciamentoVisualizacaoDadosEdital.vue?vue&type=script&lang=js&"
export * from "./CredenciamentoVisualizacaoDadosEdital.vue?vue&type=script&lang=js&"
import style0 from "./CredenciamentoVisualizacaoDadosEdital.vue?vue&type=style&index=0&id=519f1f1e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports